<template>
  <div id="app">
    <router-view/>    
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: '河南画室_郑州画室_河南美术培训_郑州美术培训',
      // all titles will be injected into this template
      titleTemplate: '%s-郑州拙一画室',
      meta: [
          { name: "keywords", content: "河南画室,郑州画室,河南美术培训,郑州美术培训" },
          { name: "description", content: "郑州画室,郑州美术培训首选拙一画室,多年专注河南画室,郑州画室,河南美术培训,郑州美术培训,为国内各大美术院校输送优秀学生,河南美术培训咨询:15136178098(王)." },
      ],
  },
  components: {
      
  },
  data () {
      return {
        mbrowser: false,
      }
   },
  mounted(){
    if (this.isMobile()) {
          //console.log('手机端')
          this.mbrowser = true
    } else {
          //console.log('pc端')
          this.mbrowser = false
     }
     this.$store.commit("mbrowser", this.mbrowser)
  },
  methods:{

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue